define('modules/home/sidebar/views/search.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'modules/home/dashboard/views/dashboard.main.view',
    'modules/base/views/base.search.reset.view',
    'text!modules/home/sidebar/templates/search.template.html'
], function(
    Prospector,
    $,_,Backbone,
    Marionette,
    MainView,
    BaseSearchResetView,
    Template
){
    var SearchView = MainView.extend({
        template: _.template(Template),
        className: 'searchDrawer',
        searchSize: 100,
        preLoadedContentSelector: '.searchResultsRow',
        loader: '.rippleHolder',
        initialize:function(options){
            MainView.prototype.initialize.apply(this, options);
            Prospector.off('runSubSearch');
            Prospector.on('runSubSearch', this.runSubSearch, this);
            this.checkHeader();
        },
        onRender: function() {
            this.$('#searchToggle').bootstrapSwitch({onText: 'Yes', offText: 'No', onColor: 'primary', offColor:'primary'}).on('switchChange.bootstrapSwitch', $.proxy(function(event, state) {
                this.toggleSearch(event);
            }, this));

            //Render all 4 inputs here
            var baseSearchResetView = new BaseSearchResetView();
            this.$('.main').append(baseSearchResetView.render().el);
            this.$('.main input').attr("placeholder", "Search for people and companies");

            var baseSearchResetView2 = new BaseSearchResetView();
            this.$('.lastName').append(baseSearchResetView2.render().el);
            this.$('.lastName input').attr("placeholder", "Last Name");

            var baseSearchResetView3 = new BaseSearchResetView();
            this.$('.companyName').append(baseSearchResetView3.render().el);
            this.$('.companyName input').attr("placeholder", "Company Name");

            var baseSearchResetView4 = new BaseSearchResetView();
            this.$('.titleRole').append(baseSearchResetView4.render().el);
            this.$('.titleRole input').attr("placeholder", "Title/Role");

            this.sessionSearch();
        },
        runSubSearch:function(options){
            _.each(options, function(value, attr){
                if(attr != "state"){
                    this.$('.'+ attr+ ' input').val(value);
                }
                //logic to show and hide individual toggled fields
                if(this.$('.'+ attr+ ' input').val() != undefined && this.$('.'+ attr+ ' input').val().length > 0){
                    this.$('.'+ attr+ ' .reset_icon').show();
                } else {
                    this.$('.'+ attr+ ' .reset_icon').hide();
                }
            }, this);
            this.state = options.state;
            this.tab = options.tab;
            if(this.tab != undefined && this.tab == "organization"){
                this.showOrg();
            } else {
                this.showPeople();
            }
            if(options.glueData != undefined){
                window.glueContact = options.glueData.contact;
                window.glueNativeIds = options.glueData.nativeIds
                //this.$('.main').val(window.glueContact.fullName);
            }
            this.$('#searchToggle').bootstrapSwitch('state', !this.state);
            this.procSearch();
        },
        toggleSearch:function(){
            MainView.prototype.toggleSearch.call(this);
            if(this.$('#searchToggle').bootstrapSwitch('state')){
                this.$('.searchResultsRow').addClass('searchInputHolderExtended');
                this.$('.main input').attr("placeholder", "First Name");
            }else{
                this.$('.searchResultsRow').removeClass('searchInputHolderExtended');
                this.$('.main input').attr("placeholder", "Search for people and companies");
            }

        },
        mEvents: function(){
            var parent = MainView.prototype.mEvents.apply(this);
            var base = {
                'click .peopleResBtn' : 'showPeople',
                'click .orgResBtn'    : 'showOrg',
                'keyup .refinePeopleResults' : 'filterPeopleResults',
                'keyup .refineOrgResults' : 'filterOrgResults',
                'click .personCheckBox' : 'filterPeopleResults',
                'click .orgCheckBox' : 'filterOrgResults',
                'click input[name="showPastRoles"]' : 'procSearch',
                'click .reset_icon'    : 'resetSearch'
            };
            $.extend(base, parent);
            return base;
        },
        getInputString:function(){
            var val = "";
            if(this.$('#searchToggle').bootstrapSwitch('state')){
                val = this.$('.main input').val();
                val += this.$('.lastName input').val();
                val += this.$('.companyName input').val();
                val += this.$('.titleRole input').val();

            } else {
                val = this.$('.main input').val();
            }

            return $.trim(val);
        },
        procSearch:function(session){
            this.$('.filter input[type="checkbox"]').prop('checked', false);
            this.$('.filter input[type="text"]').val('');
            MainView.prototype.procSearch.apply(this, [session]);
        },
        showLoader:function(){
            this.$('.searchResults').show();
            this.$('.searchResultsHolder').show();
            this.$('.peopleResults').empty().append('<div></div><div></div>');
            this.$('.orgResults').empty().append('<div></div><div></div>');
            this.$('.manualContactHolder').hide();
            this.$('.peopleResults').addClass(this.whiteLoaderClass);
            this.$('.orgResults').addClass(this.whiteLoaderClass)
        },
        hideLoader:function(){
            this.$('.peopleResults').empty();
            this.$('.orgResults').empty();
            this.$('.peopleResults').removeClass(this.whiteLoaderClass);
            this.$('.orgResults').removeClass(this.whiteLoaderClass);
        },
        buildSearch:function(event){
            if(event.keyCode != 13){
                MainView.prototype.buildSearch.call(this, event);
            }
        },
        procBuildSearch:function(){
            this.hideLoader();
            if(this.contactSearchModel.isValid()){
                this.buildPeopleResults();
                this.buildOrgResults();
                this.updateCount();
                if(this.contactSearchModel.session){
                    this.sessionTab();
                }else{
                    this.chooseGreater();
                }
            } else {
                this.$('.searchResults').fadeOut();
                this.errOut(this.contactSearchModel.errorMessage);
            }
        },
        procTimeBuildSearch:function(val, session){
            var that = this;
            if(val == this.getInputString()){
                require(["modules/base/models/contact.search.model"],
                    function(ContactSearchModel){
                        that.contactSearchModel = new ContactSearchModel();
                        that.contactSearchModel.state = that.$('#searchToggle').bootstrapSwitch('state');
                        that.contactSearchModel.pageSize = that.searchSize;
                        if(that.$('#searchToggle').bootstrapSwitch('state')){
                            that.contactSearchModel.firstName = that.getStringValue(that.$('.main input').val());
                            that.contactSearchModel.lastName = that.getStringValue(that.$('.lastName input').val());
                            that.contactSearchModel.orgName = that.getStringValue(that.$('.companyName input').val());
                            that.contactSearchModel.title = that.getStringValue(that.$('.titleRole input').val());

                            window.utils.writeSessionStorageField("fname", that.contactSearchModel.firstName);
                            window.utils.writeSessionStorageField("lname", that.contactSearchModel.lastName);
                            window.utils.writeSessionStorageField("org", that.contactSearchModel.orgName);
                            window.utils.writeSessionStorageField("title", that.contactSearchModel.title);
                            window.utils.writeSessionStorageField("state", "true");
                        } else {
                            that.contactSearchModel.query = val;
                            window.utils.writeSessionStorageField("searchQuery", val);
                            window.utils.writeSessionStorageField("state", "false");
                        }
                        if(session){
                            that.contactSearchModel.session = true;
                        }
                        that.cleanMySubviews();
                        that.showLoader();
                        that.contactSearchModel.showPastRoles = that.$('input[name="showPastRoles"]:checked').val();
                        that.contactSearchModel.bind('sync', that.procBuildSearch, that);
                        that.contactSearchModel.fetch();
                    });
            }
        },
        showOrg:function(){
            this.hideResults();
            this.$('.orgResultContainer').show();
            this.$('.orgResBtn').addClass('active');
            window.utils.writeSessionStorageField("showTab", "org");
        },
        showPeople:function(){
            this.hideResults();
            this.$('.peopleResultContainer').show();
            this.$('.peopleResBtn').addClass('active');
            window.utils.writeSessionStorageField("showTab", "people");
        },
        hideResults:function(e){
            this.$('.searchTypes div').removeClass('active');
            this.$('.peopleResultContainer').hide();
            this.$('.orgResultContainer').hide();
        },
        filterPeopleResults:function(){
            this.cleanMySubviews(this.subviews[0]);
            this.subviews[0] = new Array();
            this.$('.peopleResults').empty();
            this.$('.peopleResults').addClass(this.whiteLoaderClass);
            var peopleArr = new Array();
            //var textFilter = this.$('.refinePeopleResults').val().toLowerCase();
            var hasDirectPhone = this.$('.personHasDirectNumber').prop('checked');
            var hasCompanyPhone = this.$('.personHasCompanyNumber').prop('checked');
            var hasEmail = this.$('.personEmail').prop('checked');
            var hasCV = this.$('.personCV').prop('checked');
            _.each(this.contactSearchModel.get('individuals'), function(model){
                var add = true;

                if(add && hasDirectPhone){
                    add = model.hasDirectPhone == true;
                }
                if(add && hasCompanyPhone){
                    add = model.hasCompanyPhone == true;
                }
                if(add && hasEmail){
                    add = model.hasEMails == true;
                }
                if(add && hasCV){
                    add = model.hasCV == true;
                }

                if(add){
                    peopleArr.push(model);
                }

            }, this);
            this.$('.peopleResults').removeClass(this.whiteLoaderClass);
            this.buildPeopleCollectionViews(peopleArr);
            this.updateCount();
        },
        chooseGreater:function() {
            if (this.tab == undefined || this.tab == "") {
                if(
                    this.contactSearchModel.get('individuals') != undefined &&
                    this.contactSearchModel.get('organizations') != undefined &&
                    this.contactSearchModel.get('individuals').length >= this.contactSearchModel.get('organizations').length
                ){
                    this.showPeople();
                } else {
                    this.showOrg();
                }
            } else {
                this.tab = "";
            }
        },
        buildCollectionViews:function(collection, viewHolder, type, index){
            var that = this;
            require(['modules/home/sidebar/views/search.result.view'],
                function(SearchResultView) {
                    var i = 0;
                    _.each(collection, function (model) {
                        model.identityType = type;
                        var srv = new SearchResultView({model: model, filter: that.getFilter(), sequence: i, parent: that});
                        that.$(viewHolder).append(srv.render().el);
                        if(that.subviews[index] != undefined){
                            that.subviews[index].push(srv);
                        }
                        if(i == (collection.length - 1)){
                            that.launchManualContact(collection, type);
                        }
                        i++;
                    }, that);
                });
        },
        launchManualContact:function(collection, type){
            var container = "";
            if(type == 'person'){
                container = ".peopleResultContainer";
            } else {
                container = ".orgResultContainer";
            }
            this.$(container + ' .manualContactHolder').show();
            if(collection != undefined && collection.length < 10){
                this.$(container + ' .manualContactHolder.bottom').hide();
            } else if(collection == undefined){
                this.$(container + ' .manualContactHolder').hide();
            }
        },
        buildPeopleCollectionViews:function(collection){
            MainView.prototype.buildPeopleCollectionViews.call(this, collection);
            if(collection != undefined && collection.length == 0){
                this.$('.peopleResultContainer .manualContactHolder').show();
                this.$('.peopleResultContainer .manualContactHolder.bottom').hide();
            }
        },
        buildOrgCollectionViews:function(collection){
            MainView.prototype.buildOrgCollectionViews.call(this, collection);
            if(collection != undefined && collection.length == 0){
                this.$('.orgResultContainer .manualContactHolder').show();
                this.$('.orgResultContainer .manualContactHolder.bottom').hide();
            }
        },
        filterOrgResults:function(){
            this.cleanMySubviews(this.subviews[1]);
            this.subviews[1] = new Array();
            this.$('.orgResults').empty();
            this.$('.orgResults').addClass(this.whiteLoaderClass);
            var orgArr = new Array();

            var hasNumber = this.$('.orgHasNumber').prop('checked');
            var hasAddress = this.$('.orgHasAddress').prop('checked');
            var hasCV = this.$('.orgHasCv').prop('checked');

            _.each(this.contactSearchModel.get('organizations'), function(model){
                var add = true;

                if(add && hasNumber){
                    add = model.hasPhoneNumbers == true;
                }
                if(add && hasAddress){
                    add = model.hasLocations == true;
                }

                if(add && hasCV){
                    add = model.hasCV == true;
                }

                if(add){
                    orgArr.push(model);
                }

            }, this);
            this.$('.orgResults').removeClass(this.whiteLoaderClass);
            this.buildOrgCollectionViews(orgArr);
            this.updateCount();
        },
        updateCount:function(){
            MainView.prototype.updateCount.apply(this);
            this.$('.peopleCount').html(this.indivCount);
            this.$('.orgCount').html(this.orgCount);
        },
        checkHeader: function(){
            if($('nav > .p-nav > .row > .col-xs-3').hasClass('search-ex')){
                $('nav').empty();
                require(['text!modules/home/main/templates/chrome.header.template.html'], function(DefaultHeader){
                    $('nav').append(DefaultHeader);
                });
            }
        },
        sessionSearch: function(){
            if(window.utils.readSessionStorageField("state") == "true"){
                this.$('#searchToggle').bootstrapSwitch('state', true);
                this.$('.main input').val(window.utils.readSessionStorageField("fname"));
                this.$('.lastName input').val(window.utils.readSessionStorageField("lname"));
                this.$('.companyName input').val(window.utils.readSessionStorageField("org"));
                this.$('.titleRole input').val(window.utils.readSessionStorageField("title"));
                if(this.$('.main input').val().length > 0 ||
                    this.$('.lastName input').val().length > 0 ||
                    this.$('.companyName input').val().length > 0 ||
                    this.$('.titleRole input').val().length > 0)
                {
                    this.procSearch(true);
                }
            } else {
                this.$('#searchToggle').bootstrapSwitch('state', false);
                this.$('.main input').val(window.utils.readSessionStorageField("searchQuery"));
                if(this.$('.main input').val().length > 0) {
                    this.procSearch(true);
                }
            }
        },
        sessionTab: function(){
            if(window.utils.readSessionStorageField("showTab") == "people"){
                this.showPeople();
            } else{
                this.showOrg();
            }
        }
    });
    return SearchView;
});
